import { useEffect, Fragment } from 'react';
import { shape, bool } from 'prop-types';
import { InputsContainer } from 'shared/containers';
import { PercentageField, RadioButtonField, CheckboxField } from 'shared/fields';
import { Heading, Info, LabelText } from 'shared/components';
import { useNavigate } from 'react-router-dom';

const InterestRate = ({ values: { interest_rate_unknown }}) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/hypotheekbespaarcheck/interest-rate');
  }, [navigate]);

  return <>
    <Heading>Hypotheekrente</Heading>
    <InputsContainer>
      <LabelText>
        Hoeveel procent rente betaal je nu? (vul het hoogste in als je meerdere leningdelen hebt)
        <Info title='Hoeveel procent rente betaal je nu?'>
          Soms heeft een hypotheek meerdere leningdelen met verschillende
          rentes. Na onze eerste indicatie, kun je deze informatie aanvullen
          en krijg je een nauwkeuriger berekening.
        </Info>
      </LabelText>
      <PercentageField placeholder="Rente" name="interest_rate" disabled={interest_rate_unknown}/>
      <CheckboxField label="Ik weet het niet" name="interest_rate_unknown" id="interest_rate_unknown"/>
      {interest_rate_unknown && (
        <Fragment>
          <LabelText>Wat is ongeveer de (hoogste) hypotheekrente die je betaalt?</LabelText>
          <div css={{marginTop: '14px'}}>
            <RadioButtonField name="estimated_interest_rate" value={'1-3'}>
              0% tot 3%
            </RadioButtonField>
            <RadioButtonField name="estimated_interest_rate" value={'3-5'}>
              3% tot 5%
            </RadioButtonField>
            <RadioButtonField name="estimated_interest_rate" value={'5-8'}>
              Meer dan 5%
            </RadioButtonField>
          </div>
        </Fragment>
      )}
    </InputsContainer>
  </>;
}

InterestRate.propTypes = {
  values: shape({
    interest_rate_unknown: bool,
  }).isRequired,
};

export default InterestRate;
